export const pluralize = require("pluralize");
